<template>
  <section>
    <top-menu/>

    <section>
      <page-header :headerName="'Engajamento'" :showBtn="true" :btnName="'Voltar'"
                   :btnRoute="'/avisos-e-campanhas'" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">

          <!--
            Enquanto algum banco não responder, TODO número desta página está
            incompleto: podem faltar até um oitavo da plataforma. Dizer isso é
            obrigatório — um total que omite um banco em silêncio é pior do que
            não mostrar número nenhum.
          -->
          <div class="col-xs-12 be-warn" v-if="shardFailures.length">
            <p class="be-warn__line">
              Números incompletos: {{ shardNames }} não respondeu. Falta desta tela
              o que estiver nesse banco.
            </p>
            <!--
              O motivo, e não só o nome do banco. Sem ele, uma consulta que não
              traduz e um banco fora do ar produzem a mesma frase, e não há como
              saber qual dos dois aconteceu sem abrir o servidor.
            -->
            <ul class="be-warn__why">
              <li v-for="failure in shardFailures" :key="failure.shardId">
                {{ failure.shardName || failure.shardId }}: {{ failure.error || 'motivo não informado' }}
              </li>
            </ul>
          </div>

          <div class="col-xs-12 default-box be-head">
            <div class="be-head__row">
              <h2 class="be-title">{{ campaign.title || 'Campanha' }}</h2>
              <button type="button" class="btn default" :disabled="engagementFailed || loadingEngagement"
                      @click="exportSummary">
                Exportar resumo
              </button>
            </div>
            <p class="be-meta" v-if="campaign.id">
              {{ typeLabel }} · {{ period }} ·
              <span class="be-chip" :class="statusClass">{{ statusLabel }}</span>
            </p>
            <p class="be-meta be-meta--muted" v-else-if="campaignFailed">
              Não foi possível carregar os dados da campanha. Os números abaixo
              continuam válidos.
            </p>
          </div>

          <!-- ================================================== funil -->
          <div class="col-xs-12 default-box">
            <!--
              "Funil" aqui e a CONVERSAO desta campanha (visto, clicado), nao o
              funil de CS da empresa. Os dois existem no Master e o nome curto
              fazia um passar pelo outro.
            -->
            <h3 class="bc-section">Conversão da campanha</h3>

            <p class="be-warn be-warn--error" v-if="engagementFailed">
              Não foi possível carregar o engajamento desta campanha. Recarregue a
              página para tentar de novo.
            </p>

            <div class="be-funnel" v-else-if="!loadingEngagement">
              <!--
                Empresas ficam FORA do funil, sem barra. A etapa seguinte conta
                pessoas, e uma barra de empresas ao lado de uma barra de pessoas
                convida a comparar os comprimentos — comparação que não significa
                nada entre unidades diferentes.
              -->
              <div class="be-reach">
                <span class="be-stage__value">{{ number(data.targetedCompanies) }}</span>
                <span class="be-stage__label">empresas direcionadas</span>
              </div>

              <div class="be-stage" v-for="stage in funnel" :key="stage.key">
                <div class="be-stage__head">
                  <span class="be-stage__label">{{ stage.label }}</span>
                  <span class="be-stage__value">{{ number(stage.value) }}</span>
                  <span class="be-stage__unit">{{ stage.unit }}</span>
                </div>
                <div class="be-track">
                  <div class="be-fill" :class="'be-fill--' + stage.key"
                       :style="{ width: stage.width }"></div>
                </div>
                <!--
                  A taxa aparece entre etapas, não dentro delas: o que interessa
                  é a queda de uma para a outra. Entre empresas e pessoas não há
                  taxa nenhuma — são unidades diferentes, e dividir uma pela
                  outra produziria um número com cara de porcentagem e sem
                  significado.
                -->
                <p class="be-rate" v-if="stage.rate">{{ stage.rate }}</p>
              </div>

              <div class="be-outcome">
                <!--
                  Dispensa não é a última etapa da mesma descida: é o desfecho
                  oposto ao clique, não um passo depois dele. Empilhar as duas na
                  mesma coluna faria parecer que quem dispensou antes clicou.
                -->
                <div class="be-stage__head">
                  <span class="be-stage__label">Dispensaram</span>
                  <span class="be-stage__value">{{ number(data.dismissed) }}</span>
                  <span class="be-stage__unit">pessoas</span>
                </div>
                <div class="be-track">
                  <div class="be-fill be-fill--dismissed"
                       :style="{ width: widthOf(data.dismissed, data.delivered) }"></div>
                </div>
                <p class="be-rate" v-if="data.delivered">
                  {{ rateOf(data.dismissed, data.delivered) }} de quem recebeu
                </p>
              </div>

              <p class="be-note">
                Entregue significa entregue ao app, não pintado na tela.
                <template v-if="inflatedDelivery">
                  Nesta campanha o app do colaborador descarta o tipo no cliente
                  depois de a entrega já ter sido contada: nessa superfície,
                  Entregues está estruturalmente inflado.
                </template>
              </p>
            </div>

            <!-- ======================================= por superfície -->
            <template v-if="!engagementFailed && !loadingEngagement">
              <h3 class="bc-section">Por superfície</h3>

              <framed-table class="be-table" v-if="surfaces.length">
                <thead>
                <tr>
                  <th>Superfície</th>
                  <th class="be-num">Entregues</th>
                  <th class="be-num">Dispensas</th>
                  <th class="be-num">Cliques</th>
                  <th class="be-num">Clicaram</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in surfaces" :key="row.surface">
                  <td>{{ surfaceLabel(row.surface) }}</td>
                  <td class="be-num">{{ number(row.delivered) }}</td>
                  <td class="be-num">{{ number(row.dismissed) }}</td>
                  <td class="be-num">{{ number(row.clicks) }}</td>
                  <td class="be-num">{{ number(row.clickers) }}</td>
                </tr>
                </tbody>
              </framed-table>

              <p class="be-empty" v-else>
                Nenhuma entrega registrada ainda, em nenhuma superfície.
              </p>

              <p class="be-note">
                As faixas não somam o total do topo: a mesma pessoa pode clicar no
                Backoffice e no app e conta uma vez em cada. "Não informada" são as
                linhas criadas por uma dispensa, cuja rota não carrega superfície.
              </p>
            </template>
          </div>

          <!-- ================================================= empresas -->
          <div class="col-xs-12 default-box">
            <h3 class="bc-section">Empresas</h3>

            <p class="be-warn be-warn--error" v-if="engagementFailed">
              Não foi possível carregar as empresas desta campanha.
            </p>

            <template v-else-if="!loadingEngagement">
              <!-- A barra aparece SEMPRE: escondida em campanha sem entrega, a
                   exportacao parecia nao existir. Sem linhas os botoes ficam
                   desabilitados, que e a resposta honesta. -->
              <div class="be-toolbar">
                <input type="text" class="form-control be-search" v-model="term"
                       placeholder="Filtrar por nome ou id da empresa">
                <button type="button" class="btn default be-export"
                        :disabled="!visibleCompanies.length" @click="exportCompanies">
                  Exportar empresas
                </button>
                <button type="button" class="btn default" :disabled="exportingPeople || !companies.length"
                        @click="exportAllPeople">
                  {{ exportingPeople ? 'Gerando…' : 'Exportar todas as pessoas' }}
                </button>
              </div>

              <!-- Busca e ordenacao valem para a lista inteira; so entao a
                   tabela corta a pagina. Sem zebrado: com um tbody por
                   empresa, o Bootstrap listraria toda linha principal. -->
              <paged-table class="be-table be-table--rows" v-if="visibleCompanies.length"
                           :rows="visibleCompanies" :striped="false"
                           storage-key="broadcast-engagement-companies" v-slot="{ rows: pageCompanies }">
                <thead>
                <tr>
                  <th v-for="column in columns" :key="column.key"
                      :class="[column.numeric ? 'be-num' : '', 'be-sortable']"
                      :aria-sort="ariaSort(column.key)"
                      @click="sortBy(column.key)">
                    {{ column.label }}<span class="be-caret" v-if="sortKey === column.key">{{ caret }}</span>
                  </th>
                </tr>
                </thead>

                <!--
                  Um tbody por empresa para que o detalhe entre logo abaixo da
                  própria linha. Ele fica na tabela, e não numa modal, porque a
                  pergunta seguinte do operador é comparar com a linha de cima — e
                  uma modal cobre justamente a comparação.
                -->
                <tbody v-for="row in pageCompanies" :key="keyOf(row)">
                <tr class="be-row" :class="{ 'is-open': expanded === keyOf(row) }"
                    tabindex="0"
                    @click="toggle(row)"
                    @keydown.enter.prevent="toggle(row)"
                    @keydown.space.prevent="toggle(row)">
                  <td>{{ row.companyName || row.companyId }}</td>
                  <td>{{ row.contextCode }}</td>
                  <td class="be-num">{{ number(row.delivered) }}</td>
                  <td class="be-num">{{ number(row.clickers) }}</td>
                  <td class="be-num">{{ number(row.clicks) }}</td>
                  <td class="be-num">{{ number(row.dismissed) }}</td>
                  <td>{{ dateTime(row.lastClickAt) }}</td>
                </tr>

                <tr v-if="expanded === keyOf(row)" class="be-detail-row">
                  <td colspan="7">
                    <div class="be-detail">
                      <p class="be-empty" v-if="detailLoading">Carregando as pessoas…</p>

                      <p class="be-warn be-warn--error" v-else-if="detailFailed">
                        Não foi possível carregar as pessoas desta empresa.
                      </p>

                      <p class="be-warn" v-else-if="detail.shardFailed">
                        O banco {{ detail.shardName || detail.shardId }} não respondeu.
                        Não dá para dizer quem recebeu nesta empresa.
                        <template v-if="detail.shardError"> ({{ detail.shardError }})</template>
                      </p>

                      <template v-else>
                        <p class="be-meta be-meta--muted">
                          {{ number(detail.delivered) }} receberam ·
                          {{ number(detail.clickers) }} clicaram ·
                          {{ number(detail.clicks) }} cliques ·
                          {{ number(detail.dismissed) }} dispensaram
                          <template v-if="detail.truncated">
                            · mostrando as {{ detail.users.length }} entregas mais recentes
                          </template>
                        </p>

                        <button type="button" class="btn default be-export"
                                v-if="detail.users && detail.users.length"
                                @click.stop="exportPeople(row)">
                          Exportar pessoas
                        </button>

                        <paged-table class="be-table" v-if="detail.users && detail.users.length"
                                     :rows="detail.users" storage-key="broadcast-engagement-people"
                                     v-slot="{ rows: pageUsers }">
                          <thead>
                          <tr>
                            <th>Pessoa</th>
                            <th style="width:130px">Superfície</th>
                            <th style="width:150px">Recebeu</th>
                            <th style="width:150px">Dispensou</th>
                            <th class="be-num" style="width:80px">Cliques</th>
                            <th style="width:150px">Último clique</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="user in pageUsers" :key="user.userId">
                            <td>
                              {{ user.userName || user.userId }}
                              <small class="be-sub" v-if="user.email">{{ user.email }}</small>
                            </td>
                            <td>{{ surfaceLabel(user.surface) }}</td>
                            <td>{{ dateTime(user.deliveredAt) }}</td>
                            <td>{{ dateTime(user.dismissedAt) }}</td>
                            <td class="be-num">{{ number(user.clicks) }}</td>
                            <td>{{ dateTime(user.lastClickAt) }}</td>
                          </tr>
                          </tbody>
                        </paged-table>

                        <p class="be-empty" v-else>
                          A campanha ainda não chegou a ninguém nesta empresa.
                        </p>
                      </template>
                    </div>
                  </td>
                </tr>
                </tbody>
              </paged-table>

              <p class="be-empty" v-else-if="companies.length">
                Nenhuma empresa corresponde a "{{ term }}".
              </p>

              <p class="be-empty" v-else>
                Nenhuma empresa direcionada respondeu ainda.
              </p>

              <p class="be-note">
                Em campanha para todas as empresas ativas não há linha de
                direcionamento por empresa: esta tabela mostra só quem teve
                atividade e pode ter bem menos linhas que o total do funil.
              </p>
            </template>
          </div>

          </div>
        </div>
      </div>
    </section>

    <full-loading v-if="loadingEngagement"/>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import framedTable from "../../components/default/framedTable.vue";
import pagedTable from "../../components/default/pagedTable.vue";
import { requestApiV2 } from "./broadcastApiV2Auth";
import {
  BROADCASTS,
  BROADCAST_ENGAGEMENT,
  BROADCAST_ENGAGEMENT_COMPANY,
  BROADCAST_ENGAGEMENT_EXPORT,
} from "../../../../urlConfig";
import {
  BROADCAST_SURFACE,
  BROADCAST_TYPE,
  BROADCAST_TYPE_OPTIONS,
} from "./broadcastEnums";
import {
  csvDateTime, csvFileName, downloadCsv, saveBlob, SUMMARY_HEAD, summaryRows,
} from "./broadcastExport";
import swal from "sweetalert";

/**
 * Engajamento de uma campanha, página inteira.
 *
 * Substitui o painel lateral que a listagem abria. A leitura útil aqui é de três
 * perguntas seguidas — chegou?, mexeu?, em quem? — e as três não cabem numa
 * modal: a terceira precisa de uma tabela com detalhe por linha, e a modal
 * cobria justamente a tabela que a resposta anterior deixou na tela.
 */
export default {
  name: "broadcast-engagement-page",
  components: { topMenu, pageHeader, fullLoading, framedTable, pagedTable },
  data() {
    return {
      loadingEngagement: false,
      engagementFailed: false,
      campaignFailed: false,
      data: {},
      campaign: {},
      term: '',
      sortKey: 'clicks',
      sortDir: -1,
      expanded: null,
      detail: {},
      detailLoading: false,
      detailFailed: false,
      exportingPeople: false,
      columns: [
        { key: 'companyName', label: 'Empresa' },
        { key: 'contextCode', label: 'Banco' },
        { key: 'delivered', label: 'Entregues', numeric: true },
        { key: 'clickers', label: 'Clicaram', numeric: true },
        { key: 'clicks', label: 'Cliques', numeric: true },
        { key: 'dismissed', label: 'Dispensas', numeric: true },
        { key: 'lastClickAt', label: 'Último clique' },
      ],
    };
  },
  computed: {
    broadcastId() {
      return this.$route.params.id;
    },
    companies() {
      return this.data.companies || [];
    },
    surfaces() {
      return this.data.surfaces || [];
    },
    shardFailures() {
      return this.data.shardFailures || [];
    },
    shardNames() {
      const names = this.shardFailures.map((f) => f.shardName || f.shardId);
      return names.filter((name, i) => names.indexOf(name) === i).join(', ');
    },
    /**
     * Nota de versão não redireciona: o botão da modal dispensa em vez de
     * navegar. Mostrar a etapa de clique faria toda nota de versão parecer
     * fracasso, quando não existe clique a medir.
     */
    hasClickStage() {
      return this.campaign.type !== BROADCAST_TYPE.RELEASE_NOTE;
    },
    inflatedDelivery() {
      const surfaces = this.campaign.surfaces || 0;
      const modal = this.campaign.type === BROADCAST_TYPE.RELEASE_NOTE;
      return modal && (surfaces & BROADCAST_SURFACE.WEB) !== 0;
    },
    funnel() {
      const delivered = this.data.delivered || 0;
      const stages = [
        {
          key: 'delivered',
          label: 'Entregues',
          unit: 'pessoas',
          value: delivered,
          width: delivered ? '100%' : '0%',
          // Sem denominador não há taxa. "—% clicaram" tem cara de medida e não
          // mede nada.
          rate: this.hasClickStage && delivered
            ? this.rateOf(this.data.clickers, delivered) + ' clicaram'
            : '',
        },
      ];

      if (this.hasClickStage) {
        stages.push({
          key: 'clicked',
          label: 'Clicaram',
          unit: 'pessoas',
          value: this.data.clickers || 0,
          width: this.widthOf(this.data.clickers, delivered),
          rate: '',
        });
      }

      return stages;
    },
    visibleCompanies() {
      const term = (this.term || '').trim().toLowerCase();

      const filtered = term
        ? this.companies.filter((row) =>
            ((row.companyName || '') + ' ' + row.companyId + ' ' + (row.contextCode || ''))
              .toLowerCase()
              .indexOf(term) >= 0)
        : this.companies.slice();

      const key = this.sortKey;
      const dir = this.sortDir;

      return filtered.sort((a, b) => {
        const left = a[key];
        const right = b[key];

        if (left === right) return 0;
        // Vazio sempre no fim, em qualquer direção: uma empresa sem último
        // clique não é "a mais antiga", é ausência de clique.
        if (left === null || left === undefined || left === '') return 1;
        if (right === null || right === undefined || right === '') return -1;

        if (typeof left === 'number' && typeof right === 'number') {
          return (left - right) * dir;
        }

        return String(left).localeCompare(String(right), 'pt-BR') * dir;
      });
    },
    caret() {
      return this.sortDir === 1 ? ' ↑' : ' ↓';
    },
    typeLabel() {
      const found = BROADCAST_TYPE_OPTIONS.find((o) => o.value === this.campaign.type);
      return found ? found.label : 'Tipo desconhecido';
    },
    period() {
      const start = this.date(this.campaign.startsAt);
      return this.campaign.endsAt
        ? start + ' até ' + this.date(this.campaign.endsAt)
        : start + ' — sem fim';
    },
    statusLabel() {
      if (this.campaign.cancelledAt) return 'Cancelada';
      const now = new Date();
      if (this.campaign.endsAt && new Date(this.campaign.endsAt) < now) return 'Encerrada';
      if (new Date(this.campaign.startsAt) > now) return 'Agendada';
      return 'No ar';
    },
    statusClass() {
      const label = this.statusLabel;
      if (label === 'No ar') return 'is-live';
      if (label === 'Cancelada') return 'is-cancelled';
      return 'is-muted';
    },
  },
  created() {
    this.loadEngagement();
    this.loadCampaign();
  },
  methods: {
    loadEngagement() {
      this.loadingEngagement = true;
      this.engagementFailed = false;
      requestApiV2('GET', BROADCAST_ENGAGEMENT(this.broadcastId))
        .then((response) => {
          this.data = (response && response.data) || {};
        })
        .catch(() => {
          // Falhar a leitura não pode virar número: melhor painel vazio do que
          // total inventado. Também não pode virar frase: sem a marca de falha,
          // "ninguém respondeu" apareceria igual numa queda de rede e numa
          // campanha real com zero engajamento — narrativa inventada é do mesmo
          // jeito errada que número inventado.
          this.data = {};
          this.engagementFailed = true;
        })
        .then(() => {
          this.loadingEngagement = false;
        });
    },
    /**
     * Título, tipo e período vêm da listagem porque o engajamento não os carrega
     * — ele responde sobre números, não sobre a campanha. Falhar aqui não
     * invalida nada do resto, então esta carga tem o próprio estado de erro e
     * não bloqueia a página.
     */
    loadCampaign() {
      this.campaignFailed = false;
      requestApiV2('GET', BROADCASTS)
        .then((response) => {
          const items = ((response && response.data) || {}).items || [];
          // Comparação sem caixa: a rota é montada a partir deste mesmo id, mas um
          // link digitado ou colado com outra caixa continua sendo a campanha.
          const wanted = String(this.broadcastId || '').toLowerCase();
          this.campaign = items.find((item) => String(item.id).toLowerCase() === wanted) || {};
          this.campaignFailed = !this.campaign.id;
        })
        .catch(() => {
          this.campaign = {};
          this.campaignFailed = true;
        });
    },
    keyOf(row) {
      return row.shardId + ':' + row.companyId;
    },
    toggle(row) {
      const key = this.keyOf(row);

      if (this.expanded === key) {
        this.expanded = null;
        return;
      }

      this.expanded = key;
      this.detail = {};
      this.detailFailed = false;
      this.detailLoading = true;

      // O banco vem da PRÓPRIA linha: id de empresa colide entre bancos, e
      // deduzir o banco pelo contexto da empresa devolveria "ninguém recebeu"
      // para uma empresa que recebeu.
      requestApiV2('GET', BROADCAST_ENGAGEMENT_COMPANY(this.broadcastId, row.companyId, row.shardId))
        .then((response) => {
          // Outra linha pode ter sido aberta enquanto esta resposta vinha.
          if (this.expanded !== key) return;
          this.detail = (response && response.data) || {};
        })
        .catch(() => {
          if (this.expanded !== key) return;
          this.detail = {};
          this.detailFailed = true;
        })
        .then(() => {
          if (this.expanded !== key) return;
          this.detailLoading = false;
        });
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir * -1;
        return;
      }
      this.sortKey = key;
      // Número começa do maior, texto começa do A: é o que cada um responde.
      this.sortDir = key === 'companyName' || key === 'contextCode' ? 1 : -1;
    },
    ariaSort(key) {
      if (this.sortKey !== key) return 'none';
      return this.sortDir === 1 ? 'ascending' : 'descending';
    },
    surfaceLabel(surface) {
      if (surface === BROADCAST_SURFACE.BACKOFFICE) return 'Backoffice';
      if (surface === BROADCAST_SURFACE.WEB) return 'App do colaborador';
      return 'Não informada';
    },
    widthOf(value, total) {
      if (!total) return '0%';
      const share = Math.min(100, ((value || 0) / total) * 100);
      // Piso visível só para o que existe: zero continua sem barra nenhuma.
      return (value ? Math.max(share, 1.5) : 0) + '%';
    },
    rateOf(value, total) {
      if (!total) return '—';
      return ((value || 0) / total * 100).toFixed(1).replace('.', ',') + '%';
    },
    number(value) {
      const amount = Number(value || 0);
      return isNaN(amount) ? '0' : amount.toLocaleString('pt-BR');
    },
    date(value) {
      if (!value) return '';
      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? '' : parsed.toLocaleDateString('pt-BR');
    },
    dateTime(value) {
      if (!value) return '—';
      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? '—' : parsed.toLocaleString('pt-BR');
    },
    /** Funil + "Por superficie": so numeros agregados, nenhum dado de pessoa. */
    exportSummary() {
      const incomplete = this.shardFailures.length > 0;

      const surfaces = this.surfaces.map((row) => ({
        label: this.surfaceLabel(row.surface),
        delivered: row.delivered, dismissed: row.dismissed,
        clicks: row.clicks, clickers: row.clickers,
      }));

      downloadCsv(SUMMARY_HEAD, summaryRows(this.data, surfaces, this.hasClickStage),
                  csvFileName((this.campaign.title || 'campanha') + ' resumo', incomplete));

      if (incomplete) {
        swal("Aviso", "Arquivo INCOMPLETO: um ou mais bancos não responderam. " +
             "O nome do arquivo leva essa marca.", "warning");
      }
    },
    /** Exporta tudo que a busca deixou, na ordem da tela — nao so a pagina visivel. */
    exportCompanies() {
      const incomplete = this.shardFailures.length > 0;

      const head = ['Empresa', 'Id da empresa', 'Banco', 'Entregues', 'Clicaram',
                    'Cliques', 'Dispensaram', 'Último clique'];

      const rows = this.visibleCompanies.map((row) => [
        row.companyName || row.companyId, row.companyId, row.contextCode,
        row.delivered || 0, row.clickers || 0, row.clicks || 0, row.dismissed || 0,
        csvDateTime(row.lastClickAt),
      ]);

      downloadCsv(head, rows, csvFileName((this.campaign.title || 'campanha') + ' empresas', incomplete));

      if (incomplete) {
        swal("Aviso", "Arquivo INCOMPLETO: um ou mais bancos não responderam. " +
             "O nome do arquivo leva essa marca.", "warning");
      }
    },
    /**
     * Vem do SERVIDOR: pessoa por pessoa, de todos os bancos, sem o teto de 500
     * do detalhe por empresa. O arquivo leva nome e e-mail de funcionario de
     * cliente — por isso a confirmacao.
     */
    exportAllPeople() {
      if (this.exportingPeople) return;

      swal({
        title: "Exportar todas as pessoas?",
        text: "O arquivo traz nome e e-mail de cada pessoa que recebeu esta campanha, " +
              "em todas as empresas. A exportação fica registrada com o seu usuário.",
        icon: "warning",
        buttons: ["Voltar", "Exportar"],
      }).then((confirmed) => {
        if (!confirmed) return;

        this.exportingPeople = true;

        requestApiV2('GET', BROADCAST_ENGAGEMENT_EXPORT(this.broadcastId), null, { responseType: 'blob' })
          .then((response) => {
            const failed = (response.headers || {})['x-broadcast-shards-failed'];

            saveBlob(response.data, csvFileName(
              (this.campaign.title || 'campanha') + ' todas as pessoas', !!failed));

            if (failed) {
              const names = failed.split(',').map(decodeURIComponent).join(', ');
              swal("Aviso", "Arquivo INCOMPLETO: " + names + " não responderam. " +
                   "O nome do arquivo leva essa marca.", "warning");
            }
          })
          .catch(() => {
            swal("Aviso", "Não foi possível gerar o arquivo.", "error");
          })
          .then(() => {
            this.exportingPeople = false;
          });
      });
    },
    exportPeople(row) {
      swal({
        title: "Exportar as pessoas desta empresa?",
        text: "O arquivo traz nome e e-mail das pessoas desta empresa que receberam a " +
              "campanha. Exportações feitas por este botão não ficam registradas no servidor.",
        icon: "warning",
        buttons: ["Voltar", "Exportar"],
      }).then((confirmed) => {
        if (!confirmed) return;

        const incomplete = !!this.detail.truncated;

        const head = ['Empresa', 'Banco', 'Nome', 'E-mail', 'Superfície', 'Entregue em',
                      'Dispensado em', 'Cliques', 'Último clique'];

        const rows = (this.detail.users || []).map((user) => [
          row.companyName || row.companyId, row.contextCode,
          user.userName || user.userId || '', user.email || '', this.surfaceLabel(user.surface),
          csvDateTime(user.deliveredAt), csvDateTime(user.dismissedAt),
          user.clicks || 0, csvDateTime(user.lastClickAt),
        ]);

        downloadCsv(head, rows, csvFileName(
          (this.campaign.title || 'campanha') + ' pessoas ' + (row.companyName || row.companyId), incomplete));

        if (incomplete) {
          swal("Aviso", "Arquivo INCOMPLETO: a tela mostra só as " + this.detail.users.length +
               " entregas mais recentes desta empresa. Para todas as pessoas da campanha, " +
               "use \"Exportar todas as pessoas\".", "warning");
        }
      });
    },
  },
};
</script>

<style scoped>
.default-box { margin-bottom: 20px; padding-bottom: 18px; }

.be-head { padding-top: 16px; }
.be-head__row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.be-title { margin: 0; font-size: 20px; font-weight: 700; color: #3a424e; }
.be-meta { margin: 6px 0 0; font-size: 13px; color: #4e5560; }
.be-meta--muted { color: #9ca0a7; }

.bc-section {
  width: 100%;
  margin: 18px 0 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #eceff3;
  font-size: 16px;
  font-weight: 700;
  color: #3a424e;
}

.be-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}
.be-chip.is-live { background: #ecf9ef; color: #12b937; }
.be-chip.is-cancelled { background: #fff0f2; color: #ff445d; }
.be-chip.is-muted { background: #f4f4f5; color: #4e5560; }

.be-warn {
  background: #fff9eb;
  color: #ffb800;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 16px;
}
.be-warn--error { background: #fff0f2; color: #ff445d; }
.be-warn__line { margin: 0; }
.be-warn__why {
  margin: 6px 0 0;
  padding-left: 18px;
  font-weight: 400;
  font-size: 11px;
}

/* ------------------------------------------------------------------ funil */
.be-funnel { max-width: 620px; }

.be-reach {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding-bottom: 14px;
  margin-bottom: 16px;
  border-bottom: 1px solid #eceff3;
}

.be-stage { margin-bottom: 14px; }

.be-stage__head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 5px;
}
.be-stage__label { flex: 1; font-size: 13px; color: #3a424e; }
.be-stage__value { font-size: 22px; font-weight: 700; color: #3a424e; line-height: 1; }
.be-stage__unit { font-size: 12px; color: #9ca0a7; }

.be-track { height: 10px; border-radius: 5px; background: #f1f3f6; overflow: hidden; }
.be-fill { height: 100%; border-radius: 5px; }
.be-fill--delivered { background: #1b59f8; }
.be-fill--clicked { background: #12b937; }
.be-fill--dismissed { background: #ff445d; }

.be-rate { margin: 5px 0 0; font-size: 12px; color: #4e5560; }

.be-outcome {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #eceff3;
}

.be-note { margin: 14px 0 0; font-size: 11px; color: #9ca0a7; max-width: 640px; }
.be-empty { margin: 8px 0 0; font-size: 13px; color: #4e5560; }

/* ---------------------------------------------------------------- tabelas */
.be-table th { font-size: 12px; font-weight: 600; color: #4e5560; border-bottom: 1px solid #d5d7da; }
.be-num { text-align: right; }

.be-sortable { cursor: pointer; user-select: none; white-space: nowrap; }
.be-sortable:hover { color: #1b59f8; }
.be-caret { color: #1b59f8; }

.be-table--rows tbody { border-top: 0; }
.be-row { cursor: pointer; }
.be-row:hover td { background: #f7f9fc; }
.be-row.is-open td { background: #f2f6ff; font-weight: 600; }
.be-row:focus { outline: 2px solid #1b59f8; outline-offset: -2px; }

.be-detail-row td { background: #fbfcfe; border-top: 0; }
.be-detail { padding: 4px 0 10px; }

.be-sub { display: block; font-size: 11px; color: #9ca0a7; }

.be-toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
.be-search { max-width: 320px; font-size: 13px; }
.be-export { margin-left: auto; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/broadcast/broadcastEngagementPage.vue